module.exports = __webpack_public_path__ + "img/trash-can.8c613220.svg";